import ScrollReveal from 'scrollreveal'

let doc = document;

function setCookie(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) +
        ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
}

function SmoothVerticalScrolling(eTop, time, where) {

    var eAmt = eTop / 100;
    var curTime = 0;
    while (curTime <= time) {
        window.setTimeout(SVS_B, curTime, eAmt, where);
        curTime += time / 100;
    }
}

function SVS_B(eAmt, where) {
    if (where == "center" || where == "")
        window.scrollBy(0, eAmt / 2);
    if (where == "top") {
        window.scrollBy(0, eAmt);
    }
}

doc.addEventListener("DOMContentLoaded", function (event) {

    if (doc.querySelector('.js-move-stars')) {
        doc.addEventListener('mousemove', function (e) {
            let n = doc.querySelector('.landing-view').clientHeight;
            let a = (window.innerWidth / 2 - e.clientX) / 80,
                s = (e.clientY - n / 2) / 60;

            doc.querySelector('.js-move-stars').setAttribute('style', "transform: translate3d(" + a * 0.5 + "px," + s * 0.5 + "px,0px) scale3d(1.001,1.001,1.001)");
        });
    }

    const menuLinks = document.querySelectorAll('.scroll-to');
    if (menuLinks.length > 0) {
        menuLinks.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const targetPlaceholder = link.getAttribute('href');
                const target = document.querySelector(targetPlaceholder);

                window.scroll({top: target.offsetTop - 120, behavior: 'smooth'});

                document.body.classList.remove('open-menu');
            })
        });
    }

    const tellAboutUsFull = document.querySelector('.tell-about-us--full');
    if (tellAboutUsFull) {
        let index = 0;
        const items = tellAboutUsFull.querySelectorAll('.tell-about-us__item');
        const tellAboutUsWrapper = tellAboutUsFull.querySelector('.tell-about-us__wrapper');
        const rightButton = tellAboutUsFull.querySelector('.tell-about-us__button--right');
        const leftButton = tellAboutUsFull.querySelector('.tell-about-us__button--left');


        setTimeout(() => {
            const height = items[index].querySelector('.container').clientHeight;
            tellAboutUsWrapper.style.height = height + 'px';
        }, 500);

        rightButton.addEventListener('click', function () {
            if (index === items.length - 1) return;
            index++;
            move();
        });

        leftButton.addEventListener('click', function () {
            if (index === 0) return;
            index--;
            move();
        });

        const move = () => {
            tellAboutUsWrapper.style.marginLeft = -index * 100 + 'vw';

            const height = items[index].querySelector('.container').clientHeight;
            tellAboutUsWrapper.style.height = height + 'px';

            if (index === 0) {
                leftButton.classList.add('d-none');
            } else {
                leftButton.classList.remove('d-none');
            }

            if (index === items.length - 1) {
                rightButton.classList.add('d-none');
            } else {
                rightButton.classList.remove('d-none');
            }
        }
    }

    const tellAboutUsColumns = document.querySelector('.tell-about-us--columns');
    if (tellAboutUsColumns) {
        let index = 0;
        const items = tellAboutUsColumns.querySelectorAll('.tell-about-us__item');
        const tellAboutUsWrapper = tellAboutUsColumns.querySelector('.tell-about-us__wrapper');
        const rightButton = tellAboutUsColumns.querySelector('.tell-about-us__button--right');
        const leftButton = tellAboutUsColumns.querySelector('.tell-about-us__button--left');

        let numberOfColumns = 3;
        if (window.innerWidth < 991) {
            numberOfColumns = 2;
        }

        if (window.innerWidth < 768) {
            numberOfColumns = 1;
        }

        const setHeight = (_index) => {
            const maxHeight = [...items].slice(_index * numberOfColumns, _index * numberOfColumns + numberOfColumns).reduce((acc, item) => {
                const height = item.querySelector('.container').clientHeight;
                return acc > height ? acc : height;
            }, 0);

            tellAboutUsWrapper.style.height = maxHeight + 'px';
        }

        tellAboutUsColumns.setAttribute('data-columns', numberOfColumns);

        setTimeout(() => {
            setHeight(0);
        }, 500);

        rightButton.addEventListener('click', function () {
            if (index === items.length - 1) return;
            index++;
            move();
        });

        leftButton.addEventListener('click', function () {
            if (index === 0) return;
            index--;
            move();
        });

        const move = () => {
            tellAboutUsWrapper.style.marginLeft = -index * 100 + '%';
            setHeight(index);

            if (index === 0) {
                leftButton.classList.add('d-none');
            } else {
                leftButton.classList.remove('d-none');
            }

            if (index === Math.ceil(items.length / numberOfColumns) - 1) {
                rightButton.classList.add('d-none');
            } else {
                rightButton.classList.remove('d-none');
            }
        }
    }

    const tellAboutUsOpenButton = document.querySelector('.tell-about-us__open-button');
    if (tellAboutUsOpenButton) {
        const items = document.querySelectorAll('.tell-about-us__item');
        const tellAboutUsWrapper = document.querySelector('.tell-about-us__wrapper');

        tellAboutUsOpenButton.addEventListener('click', function () {
            let numberOfColumns = 3;
            if (window.innerWidth < 991) {
                numberOfColumns = 2;
            }

            if (window.innerWidth < 768) {
                numberOfColumns = 1;
            }

            document.querySelector('.tell-about-us__container').style.display = 'block';
            tellAboutUsOpenButton.remove();
            const setHeight = (_index) => {
                const maxHeight = [...items].slice(_index * numberOfColumns, _index * numberOfColumns + numberOfColumns).reduce((acc, item) => {
                    const height = item.querySelector('.container').clientHeight;
                    return acc > height ? acc : height;
                }, 0);

                tellAboutUsWrapper.style.height = maxHeight + 'px';
            }

            setHeight(0);

        });
    }

    ScrollReveal().reveal("[data-animation-ref]", {
        origin: "bottom",
        distance: "25px",
        duration: 1e3,
        delay: 100,
        scale: 1,
        opacity: 0,
        easing: "ease-out",
        viewOffset: {
            bottom: 150
        }
    });
    if (doc.getElementById('want-light')) {
        doc.getElementById('want-light').addEventListener('click', (e) => {
            e.preventDefault();
            if (window.innerWidth > 768) {
                SmoothVerticalScrolling(document.querySelector('.light-online').getBoundingClientRect().top, 275, "top");
            } else {
                SmoothVerticalScrolling(document.querySelector('.form').getBoundingClientRect().top - 120, 400, "top");
            }
        });
    }


    let calculate = document.querySelectorAll('.calculate');
    let scrollItems = doc.querySelectorAll('.scroll-animation');

    if (window.innerWidth < 1199) {
        if (doc.querySelector('.our-stories video')) {
            doc.querySelector('.our-stories video').remove();
        }
    }

    const header = doc.querySelector('header');
    const scroll = document.documentElement.scrollTop;
    if (scroll > 0) {
        header.classList.add('scroll');
    } else {
        header.classList.remove('scroll');
    }

    const animate = () => {
        const ease = {
            linear: t => t,
            inOutQuad: t => t<.5 ? 2*t*t : -1+(4-2*t)*t,
            // Find out more at: https://gist.github.com/gre/1650294
        };

        const counter = (element) => {
            const duration = 1000;

            const symbolAfter = element.getAttribute('data-symbol-after') || '';
            const symbolBefore = element.getAttribute('data-symbol-before') || '';

            const start = parseInt(element.getAttribute('data-from'), 10);
            const end = parseInt(element.getAttribute('data-to'), 10);

            if (start === end){
                return;
            }

            const range = end - start; // Get the range
            let curr = start; // Set current at start position

            const timeStart = Date.now();
            const formatter = new Intl.NumberFormat('ru');

            const loop = () => {
                let elaps = Date.now() - timeStart;
                if (elaps > duration) {
                    elaps = duration;
                }
                const norm = ease.inOutQuad(elaps / duration); // normalised value + easing
                const step = norm * range; // Calculate the value step
                curr = start + step; // Increment or Decrement current value

                element.innerHTML = symbolBefore + formatter.format(Math.ceil(curr)) + symbolAfter;
                if (elaps < duration){
                    requestAnimationFrame(loop); // Loop
                }
            };

            requestAnimationFrame(loop); // Start the loop!
        }

        for (let i = 0; i < calculate.length; i++) {
            let symbolAfter = calculate[i].getAttribute('data-symbol-after') || '';
            let symbolBefore = calculate[i].getAttribute('data-symbol-before') || '';
            const start = calculate[i].getAttribute('data-from');
            const end = calculate[i].getAttribute('data-to');
            let type = calculate[i].getAttribute('data-type');

            calculate[i].innerHTML = symbolBefore + start + symbolAfter;

            if (type !== 'time') {
                counter(calculate[i]);
                continue;
            }

            for (let k = start; k <= end; k++) {
                setTimeout(() => {
                    let sec_num = parseInt(k, 10);
                    let hours = Math.floor(sec_num / 3600);
                    let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                    let seconds = sec_num - (hours * 3600) - (minutes * 60);
                    if (hours < 10) {
                        hours = "0" + hours;
                    }
                    if (minutes < 10) {
                        minutes = "0" + minutes;
                    }
                    if (seconds < 10) {
                        seconds = "0" + seconds;
                    }
                    calculate[i].innerHTML = hours + ':' + minutes + ':' + seconds;
                }, (k / end) * 800)
            }
        }


    }

    let animateCalculate = false;

    if (calculate.length > 0 && scroll >= calculate[0].offsetTop - window.innerHeight + 300 && !animateCalculate) {
        animateCalculate = true;
        animate();
    }

    window.addEventListener("scroll", function (e) {
        const scroll = e.scrollY || document.documentElement.scrollTop;
        if (scroll > 0) {
            header.classList.add('scroll');
        } else {
            header.classList.remove('scroll');
        }

        // Animation calculating
        if (calculate.length > 0 && scroll >= calculate[0].offsetTop - window.innerHeight + 300 && !animateCalculate) {
            animateCalculate = true;
            animate();
        }

        if (scrollItems.length > 0) {
            for (let i = 0; i < scrollItems.length; i++) {
                let item = scrollItems[i];
                let animated = item.getAttribute('data-animated');
                if (!animated && scroll >= item.getBoundingClientRect().top + scroll - window.innerHeight + 300) {
                    item.style.opacity = 1;
                    item.classList.add('animated');
                    item.setAttribute('data-animated', 'true');
                    let fromPosition = item.getAttribute('data-from');
                    if (fromPosition === 'left') {
                        item.classList.add('slideInLeft');
                    } else if (fromPosition === 'right') {
                        item.classList.add('slideInRight');
                    }
                }
            }

        }
    });
});
